import api from '../api';

export const logAction = async (action, details = {}) => {
    try {
        await api.post('/api/logAction', {
            action,
            details,
            timestamp: new Date().toISOString()
        });
    } catch (e) {
        // Silently fail - logging shouldn't affect the app
        console.debug('Logging failed:', e);
    }
};
